// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import ProductCard from "./ProductCard"; // 3 in row
// import SegmentedControl from "../../SegmentedControl/SegmentedControl";
// import styles from "./ProductSelection.module.css";

// const ProductSelection = () => {
//   const { categoryName } = useParams();
//   const [products, setProducts] = useState(null);
//   const [filteredProducts, setFilteredProducts] = useState(null);
//   const [selectedPlacement, setSelectedPlacement] = useState("All");

//   useEffect(() => {
//     async function fetchProducts() {
//       try {
//         const response = await fetch(`/categories/${categoryName}.json`);
//         if (!response.ok) throw new Error("Failed to fetch products");
//         const data = await response.json();

//         const formattedProducts = Object.keys(data).map((productName) => ({
//           image: data[productName].image_url,
//           imageUrls: data[productName].image_urls,
//           title: productName,
//           designer: data[productName].company_name,
//           description: data[productName].description,
//           originalCategory: data[productName].original_category,
//           filterCategory: data[productName].filter_category,
//           price: 120,
//           rating:
//             "https://cdn.builder.io/api/v1/image/assets/TEMP/cd6f7e9d11c8e31311a1f943dfb7d413dd37236a822e833b6f143d97b05e8b31?placeholderIfAbsent=true&apiKey=61e6847707e64adabe6b05a1c0a8e8bd",
//           placement: data[productName].placement,
//         }));

//         setProducts(formattedProducts);
//         setFilteredProducts(formattedProducts); // הצגה ראשונית של כל המוצרים
//       } catch (error) {
//         console.error("Error loading category products:", error);
//       }
//     }

//     fetchProducts();
//   }, [categoryName]);

//   useEffect(() => {
//     if (products) {
//       const filtered = products.filter((product) => {
//         if (selectedPlacement === "All") return true;
//         if (product.placement === "-") return true;
//         return product.placement.includes(selectedPlacement);
//       });
//       setFilteredProducts(filtered);
//     }
//   }, [selectedPlacement, products]);

//   if (!filteredProducts) return <p>Loading...</p>;

//   return (
//     <main className={styles.productGridContainer}>
//       {/* שילוב הכפתור */}
//       <SegmentedControl
//         selected={selectedPlacement}
//         setSelected={setSelectedPlacement}
//       />
//       <section className={styles.productGrid}>
//         {filteredProducts.map((product, index) => (
//           <ProductCard key={index} {...product} />
//         ))}
//       </section>
//     </main>
//   );
// };

// export default ProductSelection;

import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import ProductCard from "./ProductCard";
import SegmentedControl from "../../SegmentedControl/SegmentedControl";
import styles from "./ProductSelection.module.css";

const ProductSelection = ({ onCountChange, onFiltersAvailable, onProductsLoaded, activeFilters }) => {
  const { categoryName } = useParams();
  const [products, setProducts] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState(null);

  // אתחול הבחירה מ-sessionStorage
  const [selectedPlacement, setSelectedPlacement] = useState(() => {
    return sessionStorage.getItem("selectedPlacement") || "All";
  });

  // דגל כדי לוודא שהגלילה מתבצעת רק פעם אחת
  const hasScrolled = useRef(false);

  useEffect(() => {
    async function fetchProducts() {
      try {
        const response = await fetch(`/categories/${categoryName}.json`);
        if (!response.ok) throw new Error("Failed to fetch products");
        const data = await response.json();

        const formattedProducts = Object.keys(data).map((productName) => ({
          image: data[productName].image_url,
          imageUrls: data[productName].image_urls,
          title: productName,
          designer: data[productName].company_name,
          description: data[productName].description,
          originalCategory: data[productName].original_category,
          filterCategory: data[productName].filter_category,
          price: 120,
          rating:
            "https://cdn.builder.io/api/v1/image/assets/TEMP/cd6f7e9d11c8e31311a1f943dfb7d413dd37236a822e833b6f143d97b05e8b31?placeholderIfAbsent=true&apiKey=61e6847707e64adabe6b05a1c0a8e8bd",
          placement: data[productName].placement,
        })).sort((a, b) => {
          if (a.designer === 'Talenti' && b.designer !== 'Talenti') return -1;
          if (a.designer !== 'Talenti' && b.designer === 'Talenti') return 1;
          return 0;
        });

        const uniqueCompanies = [...new Set(formattedProducts.map((p) => p.designer).filter(Boolean))];
        const uniqueFilterCategories = [...new Set(formattedProducts.map((p) => p.filterCategory).filter(Boolean))];
        const uniqueOriginalCategories = [...new Set(formattedProducts.map((p) => p.originalCategory).filter(Boolean))];

        if (onFiltersAvailable) {
          onFiltersAvailable({
            companies: uniqueCompanies,
            filterCategories: uniqueFilterCategories,
            originalCategories: uniqueOriginalCategories,
          });
        }

        if (onProductsLoaded) {
          onProductsLoaded(
            formattedProducts.map((p) => ({
              designer: p.designer,
              filterCategory: p.filterCategory,
              originalCategory: p.originalCategory,
            }))
          );
        }

        setProducts(formattedProducts);
        setFilteredProducts(formattedProducts);
        if (onCountChange) onCountChange(formattedProducts.length);
      } catch (error) {
        console.error("Error loading category products:", error);
      }
    }

    fetchProducts();
  }, [categoryName, onCountChange, onFiltersAvailable, onProductsLoaded]);

  useEffect(() => {
    if (products) {
      const filtered = products.filter((product) => {
        const placementMatch =
          selectedPlacement === "All" ||
          product.placement === "-" ||
          product.placement.includes(selectedPlacement);

        const companyMatch =
          !activeFilters || activeFilters.companies.length === 0 ||
          activeFilters.companies.includes(product.designer);

        const filterCategoryMatch =
          !activeFilters || activeFilters.filterCategories.length === 0 ||
          activeFilters.filterCategories.includes(product.filterCategory);

        const originalCategoryMatch =
          !activeFilters || activeFilters.originalCategories.length === 0 ||
          activeFilters.originalCategories.includes(product.originalCategory);

        return placementMatch && companyMatch && filterCategoryMatch && originalCategoryMatch;
      });
      setFilteredProducts(filtered);
      if (onCountChange) onCountChange(filtered.length);
    }
  }, [selectedPlacement, products, onCountChange, activeFilters]);

  // גלילה למיקום שמור (רק פעם אחת)
  useEffect(() => {
    if (filteredProducts && !hasScrolled.current) {
      const scrollY = sessionStorage.getItem("scrollPosition");
      if (scrollY) {
        console.log(`get location ${scrollY}`);
        window.scrollTo(0, parseInt(scrollY));
        sessionStorage.removeItem("scrollPosition");
      } else {
        console.log("No location");
      }
      hasScrolled.current = true;
    }
  }, [filteredProducts]);

  if (!filteredProducts) return (
    <div className={styles.loaderWrapper}>
      <div className={styles.spinner} />
      <span className={styles.loaderLabel}>HOMA</span>
    </div>
  );

  return (
    <main className={styles.productGridContainer}>
      <SegmentedControl
        selected={selectedPlacement}
        setSelected={setSelectedPlacement}
      />
      <section className={styles.productGrid}>
        {filteredProducts.map((product, index) => (
          <ProductCard key={index} {...product} />
        ))}
      </section>
    </main>
  );
};

export default ProductSelection;


// אם תרצה גלילה

// import React, { useEffect, useState, useRef } from "react";
// import { useParams } from "react-router-dom";
// import ProductCard from "./ProductCard";
// import SegmentedControl from "../../SegmentedControl/SegmentedControl";
// import styles from "./ProductSelection.module.css";

// const PRODUCTS_PER_PAGE = 12; // כמה מוצרים נטען בכל פעם

// const ProductSelection = () => {
//   const { categoryName } = useParams();
//   const [products, setProducts] = useState(null);
//   const [filteredProducts, setFilteredProducts] = useState(null);

//   const [selectedPlacement, setSelectedPlacement] = useState(() => {
//     return sessionStorage.getItem("selectedPlacement") || "All";
//   });

//   const [visibleCount, setVisibleCount] = useState(() => {
//     return parseInt(sessionStorage.getItem("visibleCount")) || PRODUCTS_PER_PAGE;
//   });

//   const hasScrolled = useRef(false);

//   useEffect(() => {
//     async function fetchProducts() {
//       try {
//         const response = await fetch(`/categories/${categoryName}.json`);
//         if (!response.ok) throw new Error("Failed to fetch products");
//         const data = await response.json();

//         const formattedProducts = Object.keys(data).map((productName) => ({
//           image: data[productName].image_url,
//           imageUrls: data[productName].image_urls,
//           title: productName,
//           designer: data[productName].company_name,
//           description: data[productName].description,
//           originalCategory: data[productName].original_category,
//           filterCategory: data[productName].filter_category,
//           price: 120,
//           rating:
//             "https://cdn.builder.io/api/v1/image/assets/TEMP/cd6f7e9d11c8e31311a1f943dfb7d413dd37236a822e833b6f143d97b05e8b31?placeholderIfAbsent=true&apiKey=61e6847707e64adabe6b05a1c0a8e8bd",
//           placement: data[productName].placement,
//         }));

//         setProducts(formattedProducts);
//         setFilteredProducts(formattedProducts);
//       } catch (error) {
//         console.error("Error loading category products:", error);
//       }
//     }

//     fetchProducts();
//   }, [categoryName]);

//   useEffect(() => {
//     if (products) {
//       const filtered = products.filter((product) => {
//         if (selectedPlacement === "All") return true;
//         if (product.placement === "-") return true;
//         return product.placement.includes(selectedPlacement);
//       });
//       setFilteredProducts(filtered);
//     }
//   }, [selectedPlacement, products]);

//   // גלילה למיקום שמור (רק פעם אחת)
//   useEffect(() => {
//     if (filteredProducts && !hasScrolled.current) {
//       const scrollY = sessionStorage.getItem("scrollPosition");
//       if (scrollY) {
//         window.scrollTo(0, parseInt(scrollY));
//         sessionStorage.removeItem("scrollPosition");
//       }
//       hasScrolled.current = true;
//     }
//   }, [filteredProducts]);

//   // שמירת כמות נראית ל-sessionStorage בכל שינוי
//   useEffect(() => {
//     sessionStorage.setItem("visibleCount", visibleCount.toString());
//   }, [visibleCount]);

//   if (!filteredProducts) return <p>Loading...</p>;

//   const visibleProducts = filteredProducts.slice(0, visibleCount);
//   const hasMore = visibleCount < filteredProducts.length;

//   return (
//     <main className={styles.productGridContainer}>
//       <SegmentedControl
//         selected={selectedPlacement}
//         setSelected={setSelectedPlacement}
//       />
//       <section className={styles.productGrid}>
//         {visibleProducts.map((product, index) => (
//           <ProductCard key={index} {...product} />
//         ))}
//       </section>
//       {hasMore && (
//         <div style={{ textAlign: "center", marginTop: "2rem" }}>
//           <button onClick={() => setVisibleCount((prev) => prev + PRODUCTS_PER_PAGE)}>
//             Load More
//           </button>
//         </div>
//       )}
//     </main>
//   );
// };

// export default ProductSelection;